// Split out from MapView.tsx so these constants can be imported (by
// geoJsonLayers.tsx and by testing.tsx) without pulling in maplibre-gl —
// MapView.tsx has module-scope side effects (setWorkerUrl, the maplibre-gl
// CSS import) that a maplibre-free consumer must never trigger.

export const MAP_MIN_ZOOM = 4
export const MAP_MAX_ZOOM = 18

/** Vector layers are added with ids carrying this prefix; raster layers anchor
 *  below the first such layer so late-arriving tiles never paint over geometry. */
export const GEOJSON_LAYER_PREFIX = 'gj-'
